import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import { ContextSwitcherIcon } from '@infl-ts/ui-advocate-icons';
import { styled, Typography, useMediaQuery } from '@mui/material';
import { pipe } from 'fp-ts/function';
import { Link } from '../link';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var ContextSwitcherLink = styled(Link)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  color: ", ";\n  white-space: nowrap;\n  margin-left: auto;\n  padding-left: ", ";\n  &:visited {\n    color: ", ";\n  }\n"])), function (p) {
  return p.theme.palette.neutral.contrastText;
}, function (p) {
  return p.theme.spacing(1);
}, function (p) {
  return p.theme.palette.neutral.contrastText;
});

var ContextSwitcher = function ContextSwitcher() {
  return pipe(useMediaQuery(function (theme) {
    return theme.breakpoints.down('lg');
  }), function (isTablet) {
    return /*#__PURE__*/_jsxs(ContextSwitcherLink, {
      href: "".concat(window.location.origin, "/corporate"),
      children: [/*#__PURE__*/_jsx(ContextSwitcherIcon, {
        fontSize: isTablet ? 'medium' : 'small'
      }), !isTablet && /*#__PURE__*/_jsx(Typography, {
        sx: {
          ml: 0.5
        },
        children: "Switch to Admin View"
      })]
    });
  });
};

export default ContextSwitcher;